module.exports = __webpack_public_path__ + "img/facebook.9bb8531d.svg";